import "./BreadCrumbs.scss"
import React from "react";
import {IObject} from "../../interfaces/IObject";

export function BreadCrumbs({object, contrast = false}: { object: IObject, contrast?: boolean }) {
  return <div data-component="BreadCrumbs" style={{color: contrast ? 'white' : 'black'}}>
    <nav className="breadcrumbs">
      <ol>
        <li><a href="#" className="breadcrumbs">Region?</a></li>
        <li><a href="#" className="breadcrumbs">{object.city}</a></li>
        <li>{object.name}</li>
      </ol>
    </nav>
  </div>
}